












































import {
  defineAsyncComponent, defineComponent, computed,
} from '@vue/composition-api';
import { BaseAgreement } from '@hb/coffee-widgets-agreement';
import { Tabs, TabItem } from '@hb/coffee';
import { contractsUrl } from '@/constant';

import type { MoreCapitalResItem, MoreCapitalContract } from '@/api/ordersV2/types';

// 兼容 vue2/vue3 方式
const BaseAgreementView = defineAsyncComponent(() => Promise.resolve(BaseAgreement.view));
export default defineComponent({
  name: 'BaseAgreementView_withdrawal_waiting',
  components: {
    Tabs,
    TabItem,
    BaseAgreementView,
  },
  props: {
    /** 是否展示该组件 */
    show: {
      type: Boolean,
      required: true,
    },
    /** 倒计时 */
    duration: {
      type: Number,
      required: true,
    },
    /** 渠道数据 */
    data: {
      type: Array as () => MoreCapitalResItem[],
      required: true,
    },
    /** 当前选中的资方协议列表 */
    contractList: {
      type: Array as () => MoreCapitalContract[],
      required: true,
    },
    /** 当前选中的资方索引 */
    currentCheckFundIndex: {
      type: Number,
      required: true,
    },
    /** 当前选中的协议索引  TODO: 待组强度件修抛出钩子后接入 */
    currentContractIndex: {
      type: Number,
      required: true,
    },
  },
  emits: ['changeTab', 'update:show', 'confirm'],
  setup(props, context) {
    const contract = computed(() => props.contractList.map((item) => ({
      name: item.name,
      // TODO: 此处目前只展示自营渠道协议 ，自营都是pdf，所以需要拼接pdf_url，后续如果需要展示非自营渠道协议，需要改造此逻辑
      contentUrl: `${contractsUrl || ''}?pdf_url=${item.url}`,
    })));
    /**
     * 切换渠道
     * @param index 选中的索引
     */
    const onHeaderTabChange = (index:number) => {
      context.emit('changeTab', index);
    };

    const changeContractIndex = (index: number) => {
      context.emit('changeContractIndex', index);
    };

    /**
     * 更新显示状态
     * @param value - 显示状态
     */
    const onUpdateShow = (value:boolean) => {
      context.emit('update:show', value);
    };
    const confirm = () => {
      context.emit('confirm');
    };
    return {
      contract,
      onHeaderTabChange,
      changeContractIndex,
      onUpdateShow,
      confirm,
    };
  },
});
